/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain paragraphs preserve
// legacy className behavior across existing screens.
const BodyBold = ({
  id, children, className = '', textColor, textSize = 'text-sm/4', tokens, variant, block, align
}) => {
  if (!tokens) {
    return (
      <p className={`${textColor || 'text-copy'} ${textSize} font-h1 ${className}`} id={id}>
        {children}
      </p>
    )
  }

  return (
    <div className={className} id={id}>
      <Typography block={block} align={align} variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </div>
  )
}

BodyBold.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  textColor: PropTypes.string,
  textSize: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({}),
  block: PropTypes.bool,
  align: PropTypes.string
}

BodyBold.defaultProps = {
  variant: { size: 'medium' },
  block: true,
  align: undefined
}

export default BodyBold
